<div class="white-box" [ngSwitch]="currentScreen">
  <!-- Default screen with personal details information -->
  <ng-container *ngSwitchDefault>
    @if (personalDetails?.first_name) {
      <!-- Firstname / lastname -->
      <app-profile-field-row
        screen="name"
        [content]="personalDetails?.first_name + ' ' + (personalDetails?.last_name ? personalDetails.last_name : '')"
        [showEdit]="false"
        (changeScreen)="changeScreen($event)"
      ></app-profile-field-row>
    }
    <!-- Address -->
    <app-profile-field-row
      [label]="'account.personal-information.labels.address' | translate"
      [content]="address"
      screen="address"
      (changeScreen)="changeScreen($event)"
    ></app-profile-field-row>
    <!-- Phone -->
    <app-profile-field-row
      [label]="'account.personal-information.labels.phone' | translate"
      [content]="(personalDetails.verified_phone | formatPhone) || (personalDetails.unverified_phone | formatPhone)"
      [showEdit]="customer?.provider !== 'google' || (customer?.provider === 'google' && !hasAccountMinProspect)"
      (changeScreen)="changeScreen($event)"
      screen="phone"
    ></app-profile-field-row>
    <!-- Email -->
    <app-profile-field-row
      class="last"
      [label]="'account.personal-information.labels.email' | translate"
      [content]="personalDetails.email"
      (changeScreen)="changeScreen($event)"
      [screen]="customer?.provider === 'email' ? 'email' : ''"
    ></app-profile-field-row>
    <!-- Google Provider Alert -->
    <div class="input-box google-provider-alert" *ngIf="customer?.provider === 'google'">
      <span class="icon-i-info"></span>
      <p [innerHTML]="'profile.personalDetails.gmailDisclaimer' | translate"></p>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'name'"> Name Surname </ng-container>
  <ng-container *ngSwitchCase="'email'">
    <app-profile-email [email]="personalDetails?.email"> </app-profile-email>
  </ng-container>
  <ng-container *ngSwitchCase="'address'">
    <app-profile-address [customer]="customer" [personalDetails]="personalDetails" (discardChanges)="changeScreen('main')"></app-profile-address>
  </ng-container>
  <ng-container *ngSwitchCase="'phone'">
    <app-profile-mobile-phone
      [customer]="customer"
      [hasAccountMinProspect]="hasAccountMinProspect"
      [has3AAccountMinProspect]="has3AAccountMinProspect"
      [twoFAEnabled]="twoFAEnabled"
    ></app-profile-mobile-phone>
  </ng-container>
</div>

<app-profile-dialog-2fa-change
  *ngIf="show2FADisableModal && currentScreen === 'main'"
  (changeTwoFAModal)="close2FADisableModal()"
  (openTwoFA)="openTwoFA()"
></app-profile-dialog-2fa-change>
